<template>
  <div class="main-content-wrapper">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, onMounted } from "vue";
export default defineComponent({
  name: "App",
  components: {},
  setup() {},
});
</script>

<style lang="scss">
@import "./styles/index.scss";
.main-content-wrapper {
  height: 100%;
}
</style>
